import {useRef} from 'react';

/**
 * Provides a stable reference to the markers array.
 * The plugin already preserves object identity, but this ensures
 * the array reference itself is stable when the content hasn't changed.
 *
 * Uses the assign-during-render idiom (writing a ref during render is safe;
 * unlike useMemo, it is not called twice in Strict Mode).
 */
export function useStableMarkers(markers) {
    const prevRef = useRef(markers);

    const prev = prevRef.current;
    if (markers !== prev) {
        const same = prev != null
            && markers != null
            && markers.length === prev.length
            && markers.every((m, i) => m === prev[i]);
        if (!same) {
            prevRef.current = markers;
        }
    }

    return prevRef.current;
}
